exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".c-width{margin-right:0!important;padding:0!important;width:80px!important}.card{margin-bottom:2px}.card-body{padding:10px}.h-40{height:40%!important}.h-60{height:60%!important}.el-input-group__prepend{padding-right:10px;padding-left:10px}.el-radio-button--small .el-radio-button__inner{padding:9px 6px;font-size:10px}.el-switch__label *{font-size:.65rem}.el-radio-button{margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3889fa1f","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/tenant/pos/partials/fast_payment_garage.vue
// module id = A9U0
// module chunks = 0